import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

import { MessageWrapperComponent } from '../message-wrapper/message-wrapper.component'

@Component({
  selector: 'sb-message-typing',
  templateUrl: './message-typing.component.html',
  styleUrls: ['./message-typing.component.scss'],
  imports: [MessageWrapperComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageTypingComponent {
  @Input({ required: true }) photoUrl!: string
}
